import type { TRPCRouter } from "@alch/dx-webapp-api";
import {
  createTRPCReact,
  httpBatchLink,
  httpLink,
  splitLink,
} from "@trpc/react-query";
import type { TrpcProviderProps } from "@util/trpc/trpcClientUtils.ts";
import {
  blockImpersonationMutations,
  createHttpLinksOpt,
} from "@util/trpc/trpcClientUtils.ts";
import { API_ORIGIN } from "../deployEnv.js";

export const trpc = createTRPCReact<TRPCRouter>({});

const httpLinkOpts = createHttpLinksOpt(API_ORIGIN);

export const trpcClient = trpc.createClient({
  links: [
    blockImpersonationMutations,
    splitLink({
      condition(op) {
        // Conditionally enable HTTP batching
        return op.context.enableBatch === true;
      },
      false: httpLink(httpLinkOpts),
      true: httpBatchLink(httpLinkOpts),
    }),
  ],
});

export const WebappTrpc: TrpcProviderProps<TRPCRouter> = {
  trpc,
  trpcClient,
};
